import { status } from '../../config.ts'
import { serviceCentersPage1, serviceCenterDetails } from './data.ts'
import { isLegacyLocationMock } from '@/__mocks__/util/legacyLocation.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/workshops?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, serviceCentersPage1]
    }
  },
  {
    method: 'GET',
    path: '/workshops/1',
    reply: async () => {
      await wait()
      if (isLegacyLocationMock())
        return [
          status.ok,
          {
            data: {
              ...serviceCenterDetails.data,
              latitude: null,
              longitude: null
            }
          }
        ]
      return [status.ok, serviceCenterDetails]
    }
  },
  {
    method: 'POST',
    path: '/workshops',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/workshops/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PATCH',
    path: '/workshops/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
